/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  InAppProductsUserControllerFindBundleQueryResponse,
  InAppProductsUserControllerFindBundlePathParams,
  InAppProductsUserControllerFindBundleQueryParams,
  InAppProductsUserControllerFindBundle401,
  InAppProductsUserControllerFindBundle404,
} from '../types/InAppProductsUserControllerFindBundle.ts';

function getInAppProductsUserFindBundleUrl(platform: InAppProductsUserControllerFindBundlePathParams['platform']) {
  const res = { method: 'GET', url: `/api/user/in-app-products/bundle/${platform}` as const };
  return res;
}

/**
 * {@link /api/user/in-app-products/bundle/:platform}
 */
export async function inAppProductsUserFindBundle(
  platform: InAppProductsUserControllerFindBundlePathParams['platform'],
  params: InAppProductsUserControllerFindBundleQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    InAppProductsUserControllerFindBundleQueryResponse,
    ResponseErrorConfig<InAppProductsUserControllerFindBundle401 | InAppProductsUserControllerFindBundle404>,
    unknown
  >({ method: 'GET', url: getInAppProductsUserFindBundleUrl(platform).url.toString(), params, ...requestConfig });
  return res.data;
}
